import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl, FormArray, FormBuilder, Validators } from "@angular/forms";
import { GridOptions, RowNode } from 'ag-grid-community';

import { DatePipe } from '@angular/common';

import { debug } from 'util';
import { User } from 'src/app/models/user.model';
import { AlertService } from 'src/app/util/alert/alert.service';
import { TBBO2TherapyReportDataService } from 'src/app/tbbo2-therapy-report/tbbo2-therapy-report-data.service';
import { Constants } from 'src/app/util/constants';
import { LocalStorage } from 'src/app/util/localstorage.service';
import { BsModalService } from 'ngx-bootstrap';
import { ServiceCodesScanDataService } from './service-codes-scan-data.service';
import {ServiceCodesScanFilters, ServiceCodesScanReport, ServiceCodesScanRequest, ServiceCodesScanReportData } from 'src/app/models/service-codes-scan.model';
import { ServiceCodesScanCustomCellComponent } from './service-codes-scan-custom-cell/service-codes-scan-custom-cell.component';
import { MachineDataService } from 'src/app/admin/machine/machine-data.service';
import { ClinicDataService } from 'src/app/admin/clinic/clinic-data.service';
import { UserDataService } from 'src/app/admin/user/user-data.service';


@Component({
  selector: 'app-service-codes-scan',
  templateUrl: './service-codes-scan.component.html',
  styleUrls: ['./service-codes-scan.component.scss']
})

// @Component({
//   selector: 'ngbd-datepicker-range-popup',
//   templateUrl: './datepicker-range-popup.html',
//   styles: [`
//     .form-group.hidden {
//       width: 0;
//       margin: 0;
//       border: none;
//       padding: 0;
//     }
//     .custom-day {
//       text-align: center;
//       padding: 0.185rem 0.25rem;
//       display: inline-block;
//       height: 2rem;
//       width: 2rem;
//     }
//     .custom-day.focused {
//       background-color: #e6e6e6;
//     }
//     .custom-day.range, .custom-day:hover {
//       background-color: rgb(2, 117, 216);
//       color: white;
//     }
//     .custom-day.faded {
//       background-color: rgba(2, 117, 216, 0.5);
//     }
//   `]
// })
export class ServiceCodesScanComponent implements OnInit {

  public paddingtop: number = 160;
  public iSForm: FormGroup;
  public loggedUser: User
  private gridApi: any;
  private gridColumnApi: any;
  public columnDefs: any;
  public rowData: any;
  public originalRowData: any;
  public defaultColDef
  public servicecodesscanfilters: ServiceCodesScanFilters
  public servicecodesscanreportdata: ServiceCodesScanReportData
  public servicecodesscanreportlist: Array<ServiceCodesScanReport>
  public gridOptions : GridOptions
  public servicecodesscan: ServiceCodesScanRequest

  public clinicid
  public clinic
  public clinics
  public clinicname
  public clinicfilter

  public location
  public locationfilter
  public locationid
  public locationname
  public locationchange: boolean = true

  public machine
  public machines: Array<any> =[]
  public machinefilter
  public machineid
  public machinename
  public machinechange: boolean = true

  public machinetype
  public machinetypes: Array<any> =[]
  public machinetypefilter
  public machinetypeid
  public machinetypename
  public machinetypechange: boolean = true

  public errorlevel
  public errorlevels: Array<any> =[]
  public errorlevelfilter
  public errorlevelid
  public errorlevelname
  public errorlevelchange: boolean = true

  public severity
  public severities: Array<any> =[]
  public severityfilter
  public severityid
  public severityname
  public severitychange: boolean = true

  public clinicsforfilter: Array<any> =[]
  public locationsforfilter: Array<any> =[]
  public machinesforfilter: Array<any> =[]
  public severitiesforfilter: Array<any> =[]
  public errorlevelsforfilter: Array<any> =[]
  public machinetypesforfilter: Array<any> =[]
  public selectedClinicFilter: Array<any> =[]
  public selectedLocationFilter: Array<any> =[]
  public selectedMachineFilter: Array<any> =[]
  public selectedMachineTypeFilter: Array<any> =[]
  public selectedSeverityFilter: Array<any> =[]
  public selectedErrorLevelFilter: Array<any> =[]
  public isSuperUser
  public updateMode
  public fromdate
  public todate
  public disablePDFBtn: boolean
  public errorLevelDisabled: boolean = false

  constructor(private router: Router, private formBuilder: FormBuilder,private alertService: AlertService, private userService: UserDataService,
    private machineService: MachineDataService,private clinicService: ClinicDataService, 
    private tbbo2TherapyReportsService: TBBO2TherapyReportDataService, 
    private bsModalService :BsModalService, private serviceCodesScanService: ServiceCodesScanDataService,) {
  
      var self = this;
      this.gridOptions = {
        rowData: this.rowData,
        columnDefs: this.columnDefs,
        enableColResize: true,
        enableSorting: true,
        rowSelection: 'multiple',
        rowDeselection: true,
        rowHeight: 35,
        animateRows: true,
        rowBuffer: 20,
        context: {
          componentParent: this
        },
        paginationPageSize: 10
      };
  
      this.defaultColDef = {
        //autoHeight: true,
        resizable: true,
        filter: true,
      };
  
      this.columnDefs = [
        // {
        //   headerName: 'Severity', 
        //   field: 'severity',
        //   width: 30,
        //   cellRendererFramework: ServiceCodesScanCustomCellComponent,
        // },
        {
          headerName: 'Log Type', 
          field: 'errortype',
          width: 30,
          cellRendererFramework: ServiceCodesScanCustomCellComponent,
        },
        { 
          headerName: 'Log Description', 
          field: 'logmessage',
          width: 80
        },
        {
          headerName: 'Machine', 
          field: 'machinename',
          width: 30
        },
        {
          headerName: 'Equipment', 
          field: 'machinetype',
          width: 30,
        },
        { 
          headerName: 'Location', 
          field: 'locationname',
          width: 30
        },
        { 
          headerName: 'Firmware Version', 
          field: 'firmwareversion',
          width: 30
        },
        { 
          headerName: 'Log Time', 
          field: 'logdatetime',
          width: 40
        }
      ];
   }

  ngOnInit(): void {
    this.loggedUser   = JSON.parse(localStorage.getItem(LocalStorage.LOGGED_USER)) as User;
    if(this.loggedUser.UserRoleID == Constants.UserRoleID.AdminUser || this.loggedUser.UserRoleID == Constants.UserRoleID.User){
      this.isSuperUser = false
    } else{
      this.isSuperUser = true
    }
    this.clinicid = this.loggedUser.ClinicID
    this.fromdate = new Date(
      new Date().getFullYear(),
      new Date().getMonth() - 1,
      new Date().getDate())
    this.todate = new Date()

    this.iSForm = this.formBuilder.group({
      name: new FormControl(null),
      clinic: new FormControl(null),
      clinicname: new FormControl(null),
      location: new FormControl(null),
      locationname: new FormControl(null),
      machine: new FormControl(null),
      machinename: new FormControl(null),
      severity: new FormControl(null),
      errorlevel: new FormControl(null),
      machinetype: new FormControl(null),
      clinicfilter: new FormControl(null),
      locationfilter: new FormControl(null),
      machinefilter: new FormControl(null),
      machinetypefilter: new FormControl(null),
      errorlevelfilter: new FormControl(null),
      severityfilter: new FormControl(null),
      fromdate: new FormControl(null),
      todate: new FormControl(null)
    } );

    this.loadInitialData()
  }

  loadInitialData()
	{
    this.alertService.clear()
    this.clinicService.getClinics(this.loggedUser).subscribe(data => this.getClinicData(data))
    //this.machineService.getMachines(this.loggedUser.ClinicID, this.loggedUser).subscribe(data => this.getMachineData(data))
    this.machineService.getEquipments(this.loggedUser).subscribe(data => this.getMachineTypeData(data))
    this.getSeverityData()
    this.getErrorLevelData()
    this.resetFilters()
  }

  loadServiceCodesScanList(clinicID){
    this.servicecodesscan = new ServiceCodesScanRequest()
    this.servicecodesscan.ClinicID = clinicID
    this.servicecodesscan.FromDate = this.fromdate.toLocaleDateString()
    this.servicecodesscan.ToDate = this.todate.toLocaleDateString()
    this.serviceCodesScanService.getservicecodesscanlist(this.servicecodesscan, this.loggedUser).subscribe(data => this.getServiceCodesScanListData(data))
  }

  generatePDF()
	{
    this.alertService.clear()
    if (this.validateReportRequest()){
     this.servicecodesscanfilters = new ServiceCodesScanFilters()
     this.servicecodesscanfilters.ClinicName = this.selectedClinicFilter["ClinicName"]
     this.servicecodesscanfilters.MachineName = this.machinefilter
     if(this.machinetypefilter.MachineType == undefined || 
      this.machinetypefilter.MachineType == Constants.DefaultValues.DropDownValue ||
      this.machinetypefilter.MachineType == "" ||
      this.machinetypefilter.MachineType == null){
      this.servicecodesscanfilters.Equipment = "All"
     }else{
      this.servicecodesscanfilters.Equipment = this.machinetypefilter.MachineType
     }
     if(this.machinefilter.MachineType == undefined || 
      this.machinefilter.MachineType == Constants.DefaultValues.DropDownValue ||
      this.machinefilter.MachineType == "" ||
      this.machinefilter.MachineType == null){
      this.servicecodesscanfilters.MachineName = "All"
     }else{
      this.servicecodesscanfilters.MachineName = this.machinefilter
     }
     if(this.errorlevelfilter.ErrorLevelCode == undefined || 
      this.errorlevelfilter.ErrorLevelCode == Constants.DefaultValues.DropDownValue ||
      this.errorlevelfilter.ErrorLevelCode == "" ||
      this.errorlevelfilter.ErrorLevelCode == null){
      this.servicecodesscanfilters.ErrorLevel = "All"
     }else{
      this.servicecodesscanfilters.ErrorLevel = this.errorlevelfilter.ErrorLevelCode
     }
     if(this.severityfilter.SeverityCode == undefined || 
      this.severityfilter.SeverityCode == Constants.DefaultValues.DropDownValue ||
      this.severityfilter.SeverityCode == "" ||
      this.severityfilter.SeverityCode == null){
      this.servicecodesscanfilters.Severity = "All"
     }else{
      this.servicecodesscanfilters.Severity = this.severityfilter.SeverityCode
     }
     if(this.locationfilter == undefined || 
      this.locationfilter == Constants.DefaultValues.DropDownValue ||
      this.locationfilter == "" ||
      this.locationfilter == null){
      this.servicecodesscanfilters.LocationName = "All"
     }else{
      this.servicecodesscanfilters.LocationName = this.locationfilter
     }
     this.servicecodesscanfilters.FromDate = this.fromdate.toLocaleDateString()
     this.servicecodesscanfilters.ToDate = this.todate.toLocaleDateString()


     this.servicecodesscanreportlist = new Array<ServiceCodesScanReport>()
     this.gridApi.forEachNodeAfterFilter(node => {
      let servicecodesscanreport = new ServiceCodesScanReport()
      servicecodesscanreport.ClinicID = node.data.clinicid
      servicecodesscanreport.ClinicName = node.data.clinicname
      servicecodesscanreport.LocationID = node.data.locationid
      servicecodesscanreport.LocationName = node.data.locationname
      servicecodesscanreport.EquipmentID = node.data.equipmentid
      servicecodesscanreport.EquipmentShortName = node.data.machinetype
      servicecodesscanreport.MachineID = node.data.machineid
      servicecodesscanreport.MachineName = node.data.machinename
      servicecodesscanreport.MacAddress = node.data.macaddress
      servicecodesscanreport.LogMessage = node.data.logmessage
      servicecodesscanreport.Severity = node.data.severity
      servicecodesscanreport.ErrorLevel = node.data.errortype
      servicecodesscanreport.LogDateTime = node.data.logdatetime
      servicecodesscanreport.FirmwareVersion = node.data.firmwareversion
      this.servicecodesscanreportlist.push(servicecodesscanreport)
    });
     

     this.servicecodesscanreportdata = new ServiceCodesScanReportData()
     this.servicecodesscanreportdata.ServiceCodesScanReportList = this.servicecodesscanreportlist
     this.servicecodesscanreportdata.ServiceCodesScanFilters = this.servicecodesscanfilters
     setTimeout(() => { 
      this.serviceCodesScanService.generatservicecodesscanreportpdf(this.servicecodesscanreportdata, this.loggedUser).subscribe(data => {  
        var file = new Blob([data], {type: 'application/pdf'});
        var fileURL = URL.createObjectURL(file);
        window.open(fileURL);
        this.alertService.clear()
        this.disablePDFBtn = false
      },
      error => {
        this.alertService.clear()
        this.alertService.error('Error occured while generating pdf report')
        this.disablePDFBtn = false
      }); 
    }, 50);
    }
  }

  validateReportRequest(){
    if (this.iSForm.controls.clinicfilter.value == "" || this.iSForm.controls.clinicfilter.value == null ||
      this.iSForm.controls.clinicfilter.value == undefined)
    {
      this.alertService.clear()
      this.alertService.error('Invalid Clinic')
      return false
    }
    if ((this.iSForm.controls.fromdate.value != "") && (this.iSForm.controls.fromdate.value != null) && (this.iSForm.controls.fromdate.value == "Invalid Date"))
    {
      this.alertService.clear()
      this.alertService.error('Invalid From Date')
      return false
    }
    if ((this.iSForm.controls.todate.value != "") && (this.iSForm.controls.todate.value != null) && (this.iSForm.controls.todate.value == "Invalid Date"))
    {
      this.alertService.clear()
      this.alertService.error('Invalid To Date')
      return false
    }
    if (this.fromdate > this.todate)
    {
      this.alertService.clear()
      this.alertService.error('Invalid Date Range')
      return false
    }
    var nodes = this.gridApi.getDisplayedRowCount()
    if (nodes == 0)
    {
      this.alertService.clear()
      this.alertService.info('There are no data to generate the PDF')
      return false
    }
    return true
  }


  public getServiceCodesScanListData(data: any) {
    this.rowData = []
    this.servicecodesscanreportlist = new Array<ServiceCodesScanReport>()
    this.servicecodesscanreportlist = data
    data.forEach((element: any) => {
      let LogDateTime
      var datePipe = new DatePipe('en-US');
      if(datePipe.transform(element.LogDateTime, 'MM/dd/yyyy') != Constants.Date.MinValue){
        LogDateTime = datePipe.transform(element.LogDateTime, 'MM/dd/yyyy h:mm:ss a');
      } else{
        LogDateTime = "";
      }
      let errortype = element.Severity
      if(element.ErrorLevel != "" && element.ErrorLevel != null){
        errortype = errortype + " - " + element.ErrorLevel
      }
      this.rowData.push({clinicid: element.ClinicID, clinicname: element.ClinicName,
        locationid: element.LocationID, locationname: element.LocationName, equipmentid: element.EquipmentID,
        equipmentname: element.EquipmentName, machineid: element.MachineID, machinename: element.MachineName, 
        macaddress: element.MacAddress, machinetype: element.EquipmentShortName, 
        logdatetime: LogDateTime, logmessage: element.LogMessage, errorlevel: element.ErrorLevel, errortype: errortype,
        severity: element.Severity,firmwareversion: element.FirmwareVersion})
    });
    if(this.gridOptions.api != undefined){
      this.gridOptions.api.setRowData(this.rowData);
    }
    this.originalRowData = this.rowData
    return this.rowData;
  }

  public getClinicData(data: any) {
    this.clinics = data
    this.clinicsforfilter = []

    this.locationsforfilter = []
    this.locationsforfilter.push({LocationID: "0", LocationName: Constants.DefaultValues.DropDownValue});
    this.selectedLocationFilter = this.locationsforfilter[0]

    data.forEach((element: any, index: any) => {
		this.clinicsforfilter.push({ClinicID: element.ClinicID, ClinicName: element.ClinicName, Location: element.Location});
      if(this.clinicid != null && this.clinicid != undefined && this.clinicid == element.ClinicID){
        if(!this.isSuperUser){
          this.clinicname = element.ClinicName
          //this.clinicfilter = element.ClinicName
        }
        element.Location.forEach((e: any) => {
          if(this.locationid != null && this.locationid != undefined && this.locationid == e.LocationID){
            this.locationname = e.LocationName
          }
          this.locationsforfilter.push({LocationID: e.LocationID, LocationName: e.LocationName});
        });
        //this.selectedClinicFilter = this.clinicsforfilter[index]
        this.sortLocationRemainingFilters()
        if(this.locationchange != false){
        }
      }
    });
    return this.clinics;
  }

  public getMachineTypeData(data: any) {
    this.machinetypes = data
    this.machinetypesforfilter = []
    this.machinetypesforfilter.push({EquipmentID: 0, MachineType: "<All>"});
    data.forEach((element: any, index: any) => {
    this.machinetypesforfilter.push({EquipmentID: element.EquipmentID, MachineType: element.EquipmentShortName});
    })
    this.machinetypefilter = this.machinetypesforfilter[0]
    return this.machinetypesforfilter;
  }

  public getSeverityData() {
    this.severitiesforfilter = []
    this.severitiesforfilter.push({SeverityID: 0, SeverityCode: "<All>"}, {SeverityID: 1, SeverityCode: "LOW"},
    {SeverityID: 2, SeverityCode: "MEDIUM"},{SeverityID: 3, SeverityCode: "HIGH"},{SeverityID: 4, SeverityCode: "ERROR"});
    this.severityfilter = this.severitiesforfilter[0].SeverityCode
    return this.severitiesforfilter;
  }

  public getErrorLevelData() {
    this.errorlevelsforfilter = []
    this.errorlevelsforfilter.push({ErrorLevelID: 0, ErrorLevelCode: "<All>"}, {ErrorLevelID: 1, ErrorLevelCode: "1"},
    {ErrorLevelID: 2, ErrorLevelCode: "2"},{ErrorLevelID: 3, ErrorLevelCode: "3"});
    this.errorlevelfilter = this.errorlevelsforfilter[0].ErrorLevelCode
    return this.errorlevelsforfilter;
  }

  // exitBtnClickEvent(){
  //   this.router.navigateByUrl('landing');
  // }

  searchBtnClickEvent(){
    this.alertService.clear()
    if(this.machinetypefilter.MachineType.toLowerCase().includes("bot")){
      this.errorLevelDisabled = true
      this.errorlevelfilter = this.errorlevelsforfilter[0]
    }else{
      this.errorLevelDisabled = false
    }
    this.externalFilterChanged()
    if(this.machinefilter != null && this.machinefilter != "" && this.machinefilter == undefined){
      this.onMachineChange()
    }
  }

  externalFilterChanged() {
    if(this.gridApi != undefined){
      this.gridApi.onFilterChanged();
    }
    this.hideGridOverlay()
  }

  isExternalFilterPresent() {
    return true;
  }

  doesExternalFilterPass = (node: RowNode): boolean => {
    this.rowData
    var LocationName
    var MachineName
    var Severity
    var ErrorLevel
    var Equipment
    this.gridOptions.columnApi.setColumnVisible('machinename', true)
    this.gridOptions.columnApi.setColumnVisible('locationname', true)
    this.gridOptions.columnApi.setColumnVisible('machinetype', true)

    if(node.data.locationname != null && node.data.locationname != undefined){
      LocationName = node.data.locationname.toLowerCase()
    }
    // if(node.data.machinename != null && node.data.machinename != undefined){
    //   MachineName = node.data.machinename.toLowerCase()
    // }
    if(node.data.severity != null && node.data.severity != undefined){
      Severity = node.data.severity.toLowerCase()
    }
    if(node.data.errorlevel != null && node.data.errorlevel != undefined){
      ErrorLevel = node.data.errorlevel.toLowerCase()
    }
    if(node.data.machinetype != null && node.data.machinetype != undefined){
      Equipment = node.data.machinetype.toLowerCase()
    }

    var isLocationFilterNotPresent = (this.locationfilter == null || this.locationfilter == undefined || this.locationfilter == "" || this.locationfilter == Constants.DefaultValues.DropDownValue)
    var isMachineFilterNotPresent = (this.machinefilter == null || this.machinefilter == undefined || this.machinefilter == "")
    var isSeverityFilterNotPresent = (this.severityfilter.SeverityCode == null || 
      this.severityfilter.SeverityCode == undefined || this.severityfilter.SeverityCode == "" || 
      this.severityfilter.SeverityCode == Constants.DefaultValues.DropDownValue)
    var isErrorLevelFilterNotPresent = (this.errorlevelfilter.ErrorLevelCode == null || 
      this.errorlevelfilter.ErrorLevelCode == undefined || this.errorlevelfilter.ErrorLevelCode == "" || 
      this.errorlevelfilter.ErrorLevelCode == Constants.DefaultValues.DropDownValue)
    var isMachineTypeFilterNotPresent = (this.machinetypefilter.MachineType == null || 
      this.machinetypefilter.MachineType == undefined || this.machinetypefilter.MachineType == "" || 
      this.machinetypefilter.MachineType == Constants.DefaultValues.DropDownValue)

    //To check whether the filter is true
    var isLocationFilterTrue : boolean = false
    if (!isLocationFilterNotPresent){
      isLocationFilterTrue = (LocationName == this.locationfilter.toLowerCase())
      this.gridOptions.columnApi.setColumnVisible('locationname', false)
    }

    // var isMachineFilterTrue : boolean = false
    // if (!isMachineFilterNotPresent){
    //   isMachineFilterTrue=(MachineName.includes(this.machinefilter.toLowerCase()))
    //   this.gridOptions.columnApi.setColumnVisible('machinename', false)
    // } 

    var isMachineTypeFilterTrue : boolean = false
    if (!isMachineTypeFilterNotPresent){
      isMachineTypeFilterTrue = (Equipment == this.machinetypefilter.MachineType.toLowerCase())
      this.gridOptions.columnApi.setColumnVisible('machinetype', false)
    }

    var isSeverityFilterTrue : boolean = false
    if (!isSeverityFilterNotPresent)
      isSeverityFilterTrue = (Severity == this.severityfilter.SeverityCode.toLowerCase())
      
    var isErrorLevelFilterTrue : boolean = false
    if (!isErrorLevelFilterNotPresent){
      isErrorLevelFilterTrue = (ErrorLevel == this.errorlevelfilter.ErrorLevelCode.toLowerCase())
    }
      
    this.gridOptions.api.sizeColumnsToFit();

    // Return true for node which fulfil filter criteria
    if ((isLocationFilterNotPresent || (!isLocationFilterNotPresent && isLocationFilterTrue)) &&
        (isMachineTypeFilterNotPresent || (!isMachineTypeFilterNotPresent && isMachineTypeFilterTrue)) &&
        (isSeverityFilterNotPresent || (!isSeverityFilterNotPresent && isSeverityFilterTrue)) &&
        (isErrorLevelFilterNotPresent || (!isErrorLevelFilterNotPresent && isErrorLevelFilterTrue)))
    {
      return true
    }
    this.hideGridOverlay()
  }

  gridSizeChanged(params: any) {
		params.api.sizeColumnsToFit();
  }

  onGridReady(params: any) {
    this.rowData = []
		this.gridApi  = params.api;
    this.gridColumnApi = params.columnApi;
  }

  sortLocationRemainingFilters(){
    if(this.selectedClinicFilter["Location"] != null && this.selectedClinicFilter["Location"] != undefined){
      this.locationsforfilter = []
      this.locationsforfilter.push({LocationID: "0", LocationName: Constants.DefaultValues.DropDownValue});
      if(this.clinicfilter == Constants.DefaultValues.DropDownValue){
        this.selectedLocationFilter = this.locationsforfilter[0]
      }
      this.selectedClinicFilter["Location"].forEach((element: any) => {
        if((element.LocationName == Constants.DefaultValues.LocationName) && (element.LocationName != this.selectedLocationFilter["LocationName"])){
          this.locationsforfilter.push({LocationID: element.LocationID, LocationName: element.LocationName});
        }
      });
      this.selectedClinicFilter["Location"].forEach((element: any) => {
        if((element.LocationName != Constants.DefaultValues.LocationName) && (element.LocationName != this.selectedLocationFilter["LocationName"])){
          this.locationsforfilter.push({LocationID: element.LocationID, LocationName: element.LocationName});
        }
      });
    }
  }

  sortClinicRemainingFilters(){
    this.clinicsforfilter = []
    this.clinicsforfilter.push({ClinicID: "0", ClinicName: Constants.DefaultValues.DropDownValue, Location: null});
    if((this.selectedClinicFilter["ClinicName"] != Constants.DefaultValues.DropDownValue) && this.selectedClinicFilter != null && this.selectedClinicFilter != undefined && this.selectedClinicFilter.length != 0){
      this.clinics.forEach((element: any) => {
        if(element.ClinicName != this.selectedClinicFilter["ClinicName"]){
          this.clinicsforfilter.push({ClinicID: element.ClinicID, ClinicName: element.ClinicName, Location: element.Location});
        }
      });
    } else{
      this.clinics.forEach((element: any) => {
          this.clinicsforfilter.push({ClinicID: element.ClinicID, ClinicName: element.ClinicName, Location: element.Location});
      });
      this.selectedClinicFilter = this.clinicsforfilter[0]
    }
  }

  clinicFilter(){
    if(this.selectedClinicFilter != null && this.selectedClinicFilter != undefined){
      this.clinicid = this.selectedClinicFilter["ClinicID"]
      this.clinicname = this.selectedClinicFilter["ClinicName"]
      if(this.selectedClinicFilter.length != 0){
        this.loadServiceCodesScanList(this.clinicid)
        this.getClinicData(this.clinicsforfilter)
      }
    } else{
      this.clinicid = ""
      this.locationsforfilter = []
    }
    this.resetFilters()
	  this.searchBtnClickEvent()
  }

  locationFilter(): void {
    if(this.selectedLocationFilter != null && this.selectedLocationFilter != undefined && this.selectedLocationFilter.length != 0){
      this.locationfilter = this.selectedLocationFilter["LocationName"]
      this.sortLocationRemainingFilters()
    } else{
      this.locationfilter = Constants.DefaultValues.DropDownValue
      this.locationchange = false
      this.getClinicData(this.clinicsforfilter)
    }
    this.searchBtnClickEvent()
  }

  onStartDateChange(event){
    this.fromdate = new Date(event)
    if(this.selectedClinicFilter != null && this.selectedClinicFilter != undefined && this.selectedClinicFilter.length != 0){
      this.loadServiceCodesScanList(this.clinicid)
    }
    if(this.machinefilter != null && this.machinefilter != "" && this.machinefilter == undefined){
      this.onMachineChange()
    }
    this.hideGridOverlay()
  }

  onEndDateChange(event){
    this.todate = new Date(event)
    if(this.selectedClinicFilter != null && this.selectedClinicFilter != undefined && this.selectedClinicFilter.length != 0){
      this.loadServiceCodesScanList(this.clinicid)
    }
    if(this.machinefilter != null && this.machinefilter != "" && this.machinefilter == undefined){
      this.onMachineChange()
    }
    this.hideGridOverlay()
  }

  onMachineChange(){
    var rowdata: Array<any> = []
    if(this.machinefilter != null && this.machinefilter != "" && this.machinefilter != undefined){
      rowdata = this.originalRowData.filter( x=> x.machinename.toLowerCase().includes(this.machinefilter.toLowerCase()))
      this.rowData = rowdata
    }
    this.hideGridOverlay()
  }

  hideGridOverlay(){
    if(this.gridApi && this.gridApi.rowModel.rowsToDisplay.length == 0) {
      this.gridApi.showNoRowsOverlay();
    }
    if(this.gridApi && this.gridApi.rowModel.rowsToDisplay.length > 0) {
      this.gridApi.hideOverlay();
    }
  }

  viewBtnClickEvent(event: any){
    this.alertService.clear()
    this.alertService.info('Opening report. Please wait.')

    setTimeout(() => {
      this.tbbo2TherapyReportsService.getreportforpreview(event.sessionid, this.loggedUser).subscribe(data => {

        var file = new Blob([data], {type: 'application/pdf'});
        var fileURL = URL.createObjectURL(file);
        window.open(fileURL);
        this.alertService.clear()
      },
        error => {
          this.alertService.clear()
          this.alertService.error('Error occured while opening pdf report')
      });
    }, 50);
  }

  cancelBtnClickEvent(){
    this.clinicid = this.loggedUser.ClinicID
    this.selectedClinicFilter = []
    this.locationsforfilter = []
    this.locationsforfilter.push({LocationID: "0", LocationName: Constants.DefaultValues.DropDownValue});
    this.selectedLocationFilter = this.locationsforfilter[0]
    this.resetFilters()
    //this.externalFilterChanged()
  }

  resetFilters(){
    this.locationchange = true
    this.clinics = []
    this.clinicfilter = ""
    this.locationfilter = Constants.DefaultValues.DropDownValue
    this.errorlevelfilter = this.errorlevelsforfilter[0]
    this.machinefilter = ""
    this.machinetypefilter = this.machinetypesforfilter[0]
    this.severityfilter = this.severitiesforfilter[0]
    this.errorlevelfilter = this.errorlevelsforfilter[0]
    this.fromdate = new Date(
      new Date().getFullYear(),
      new Date().getMonth() - 1,
      new Date().getDate())
    this.todate = new Date()
    this.rowData = []
    if(this.gridOptions.api != undefined){
      this.gridOptions.columnApi.setColumnVisible('machinename', true)
      this.gridOptions.columnApi.setColumnVisible('locationname', true)
      this.gridOptions.columnApi.setColumnVisible('machinetype', true)
      this.gridOptions.api.sizeColumnsToFit();
      this.gridOptions.api.setRowData(this.rowData)
    }
  }

}



